import React from 'react'
import { Box, Flex } from 'grid-styled'
import { utils } from 'alelo-logic'

import {
  Benefits,
  GroupedSummary,
  Message,
  ResumeContent,
  Subtotal,
  SummaryCategory,
  SummaryItemNumber,
  SummaryItemTitle,
  Total,
  Values
} from './styles'

import {
  benefits,
  consumption,
  currency,
  messageTax,
  messageTax2,
  subtotal,
  total,
  veloeServices
} from './data.json'

function parseNumber(number) {
  return number < 10 ? `0${number}` : number
}

function parsePositive(number) {
  return String(number).includes('-') ? number * -1 : number
}

function parseNegative(number) {
  return String(number).includes('-') ? number : number * -1
}

function renderItems(item, index, idTransacao) {
  if (item.tipoTransacao) {
    let idQtd = `detalhe_fatura_qtd_${item.tipoTransacao.toLowerCase()}`
    let idValor = `detalhe_fatura_valor_${item.tipoTransacao.toLowerCase()}`
    return (
      <Flex align="stretch" justify="space-between" key={index}>
        <Box width={[1, 8 / 12]}>
          <SummaryItemTitle>{item.tipoTransacao}</SummaryItemTitle>
        </Box>
        <Box pl={[0, 20]} width={[1, 1 / 12]}>
          <SummaryItemNumber id={idQtd}>{parseNumber(item.quantidade)}</SummaryItemNumber>
        </Box>
        <Box pl={[0, 20]} width={[1, 3 / 12]}>
          <SummaryItemNumber id={idValor}>
            {utils.currencyParser(parsePositive(item.total), currency)}
          </SummaryItemNumber>
        </Box>
      </Flex>
    )
  }
}

function renderResume(items) {
  return items.map((item, index) => renderItems(item, index))
}

const InvoiceResume = ({
  benefitsValue,
  dataServices,
  dataConsumption,
  subtotalValue,
  totalValue
}) => {
  return (
    <div>
      {dataServices &&
        dataConsumption && (
          <ResumeContent>
            <GroupedSummary>
              <SummaryCategory>{veloeServices}</SummaryCategory>
              {renderResume(dataServices)}
            </GroupedSummary>
            <GroupedSummary>
              <SummaryCategory>{consumption}</SummaryCategory>
              {renderResume(dataConsumption)}
            </GroupedSummary>
            <Flex align="stretch" justify="space-between">
              <Box pt={6} width={[1, 9 / 12]}>
                <Subtotal>{subtotal}</Subtotal>
                <Benefits>{benefits}</Benefits>
                <Total>{total}</Total>
              </Box>
              <Box pl={[0, 20]} width={[1, 3 / 12]}>
                <Values>
                  <Subtotal id="detalhe_fatura_sub_total">
                    {utils.currencyParser(parsePositive(subtotalValue), currency)}
                  </Subtotal>
                  <Benefits id="detalhe_fatura_valor_beneficios">
                    {utils.currencyParser(parseNegative(benefitsValue), currency)}
                  </Benefits>
                  <Total id="detalhe_fatura_valor_total">
                    {utils.currencyParser(parsePositive(totalValue), currency)}
                  </Total>
                </Values>
              </Box>
            </Flex>
            <Message>{messageTax}</Message>
            <Message marginBottom>{messageTax2}</Message>
          </ResumeContent>
        )}
    </div>
  )
}

export default InvoiceResume



// WEBPACK FOOTER //
// ./src/app/modules/InvoiceResume/index.js